import { createContext } from 'react';
import { ScrollContextProps } from '../interface';

const ScrollContext = createContext<ScrollContextProps>({
  offsetStart: 0,
  renderLen: 0,
  start: 0,
});

export default ScrollContext;